import _ from 'lodash';
import pinGrey from '../assets/markers/pin-grey.svg';
import pinGreen from '../assets/markers/pin-green.svg';
import pinBlue from '../assets/markers/pin-blue.svg';
import pinOrange from '../assets/markers/pin-orange.svg';
import pinPurple from '../assets/markers/pin-purple.svg';
import stopPublic from '../assets/markers/bus-public.svg';
import stopScholar from '../assets/markers/bus-school.svg';
import school from '../assets/markers/pin-school.svg';
import depot from '../assets/markers/pin-depot.svg';
import studentPlaceholder from '../assets/kid_icon_black.png';

export const markerIcons = {
  pinGrey,
  pinGreen,
  pinBlue,
  pinOrange,
  pinPurple,
  stopPublic,
  stopScholar,
  school,
  depot,
  studentPlaceholder,
};

// Custom style for Gmaps
export const styles = [{
  featureType: 'administrative',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#444444',
  }],
}, {
  featureType: 'landscape',
  elementType: 'all',
  stylers: [{
    color: '#f2f2f2',
  }],
}, {
  featureType: 'poi',
  elementType: 'all',
  stylers: [{
    visibility: 'off',
  }],
}, {
  featureType: 'road',
  elementType: 'all',
  stylers: [{
    saturation: -100,
  }, {
    lightness: 45,
  }],
}, {
  featureType: 'road.highway',
  elementType: 'all',
  stylers: [{
    visibility: 'simplified',
  }],
}, {
  featureType: 'road.arterial',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off',
  }],
}, {
  featureType: 'transit',
  elementType: 'all',
  stylers: [{
    visibility: 'off',
  }],
}, {
  featureType: 'water',
  elementType: 'all',
  stylers: [{
    color: '#46bcec',
  }, {
    visibility: 'on',
  }],
}, {
  featureType: 'water',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#ddf7f8',
  }, {
    visibility: 'off',
  }],
}, {
  featureType: 'water',
  elementType: 'labels.text.stroke',
  stylers: [{
    weight: '3',
  }, {
    visibility: 'off',
  }],
}];

export const circleOptions = {
  fillColor: '#00af3d',
  fillOpacity: 0.4,
  strokeWeight: 2,
  strokeColor: '#009835',
  strokeOpacity: 1,
  zIndex: 1
};

export const polygonOptions = {
  fillColor: '#3399FF',
  fillOpacity: 0.4,
  strokeWeight: 2,
  strokeColor: '#2c85de',
  strokeOpacity: 1,
  zIndex: 1
};

export const polylineOptions = {
  strokeColor: '#FF6E00',
  strokeWeight: 5,
  strokeOpacity: 0.5,
};

export function setupDrawingManager(map, onShapeSelected = () => { }) {
  const drawingManager = new google.maps.drawing.DrawingManager({
    drawingControl: false,
    drawingControlOptions: {
      position: google.maps.ControlPosition.TOP_CENTER,
      drawingModes: [
        google.maps.drawing.OverlayType.CIRCLE,
        google.maps.drawing.OverlayType.POLYGON,
      ],
    },
    circleOptions: _.extend({
      clickable: true,
      editable: true,
      draggable: true,
    }, circleOptions),
    polygonOptions: _.extend({
      clickable: true,
      editable: true,
      draggable: true,
    }, polygonOptions),
  });

  drawingManager.setMap(map);

  google.maps.event.addListener(drawingManager, 'overlaycomplete', (e) => {
    const shape = e.overlay;
    shape.type = e.type;
    onShapeSelected(shape);
  });

  return drawingManager;
}

export function initPolygon(region, map) {
  const polygon = new google.maps.Polygon(
    _.extend({
      map,
      paths: region.paths,
    }, polygonOptions),
  );
  polygon.type = region.type;
  return polygon;
}

export function initCircle(center, radius, map) {
  const circle = new google.maps.Circle(
    _.extend({
      map,
      center,
      radius,
    }, circleOptions),
  );
  circle.type = 'circle';
  return circle;
}

export function removeMapObjects(...objects) {
  if (!objects) { return; }
  _.forEach(objects, (o) => {
    if (o) { o.setMap(null); }
  });
}
